<div class="telemetry-realtime-container">
  <!-- Header com Status da Conexão -->
  <div class="telemetry-header">
    <div class="connection-status" [ngClass]="connectionStatus.status">
      <span *ngIf="connectionStatus.status === 'connected'" class="status-indicator connected">
        <i class="bi bi-circle-fill"></i> {{ 'telemetry.status.connected' | transloco }}
      </span>
      <span *ngIf="connectionStatus.status === 'disconnected'" class="status-indicator disconnected">
        <i class="bi bi-circle-fill"></i> {{ 'telemetry.status.disconnected' | transloco }}
      </span>
      <span *ngIf="connectionStatus.status === 'reconnecting'" class="status-indicator reconnecting">
        <i class="bi bi-arrow-clockwise spin"></i> {{ 'telemetry.status.reconnecting' | transloco }}
      </span>
    </div>

    <div class="header-actions">
      <button *ngIf="connectionStatus.status === 'disconnected'" 
              (click)="reconnect()" 
              class="btn btn-sm btn-primary">
        <i class="bi bi-arrow-repeat"></i> {{ 'telemetry.buttons.reconnect' | transloco }}
      </button>
      <button *ngIf="connectionStatus.status === 'connected'" 
              (click)="disconnect()" 
              class="btn btn-sm btn-outline-secondary">
        <i class="bi bi-x-circle"></i> {{ 'telemetry.buttons.disconnect' | transloco }}
      </button>
    </div>
  </div>

  <!-- Dados de Telemetria -->
  <div class="telemetry-data" *ngIf="currentData">
    <div class="row">
      <!-- Card de Posição -->
      <div class="col-md-6 mb-3">
        <div class="data-card">
          <div class="card-header">
            <i class="bi bi-geo-alt-fill"></i>
            <h5>{{ 'telemetry.technical.position' | transloco }}</h5>
          </div>
          <div class="card-body">
            <div class="data-row">
              <label>{{ 'telemetry.technical.latitude' | transloco }}</label>
              <span class="value">{{ currentData.latitude | number:'1.6-6' }}°</span>
            </div>
            <div class="data-row">
              <label>{{ 'telemetry.technical.longitude' | transloco }}</label>
              <span class="value">{{ currentData.longitude | number:'1.6-6' }}°</span>
            </div>
            <div class="data-row" *ngIf="currentData.altitude !== undefined">
              <label>{{ 'telemetry.technical.altitude' | transloco }}</label>
              <span class="value">{{ currentData.altitude | number:'1.0-0' }} m</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Card de Velocidade/Direção -->
      <div class="col-md-6 mb-3">
        <div class="data-card">
          <div class="card-header">
            <i class="bi bi-speedometer2"></i>
            <h5>{{ 'telemetry.technical.speed' | transloco }}</h5>
          </div>
          <div class="card-body">
            <div class="speed-display">
              <span class="speed-value">{{ currentData.speed || 0 | number:'1.0-0' }}</span>
              <span class="speed-unit">km/h</span>
            </div>
            <div class="data-row" *ngIf="currentData.heading !== undefined">
              <label>{{ 'telemetry.technical.direction' | transloco }}</label>
              <span class="value">{{ currentData.heading | number:'1.0-0' }}°</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Card de Motor (se disponível) -->
      <div class="col-md-6 mb-3" *ngIf="currentData.rpm !== undefined || currentData.engineTemp !== undefined">
        <div class="data-card">
          <div class="card-header">
            <i class="bi bi-gear-fill"></i>
            <h5>{{ 'telemetry.technical.motor' | transloco }}</h5>
          </div>
          <div class="card-body">
            <div class="data-row" *ngIf="currentData.rpm !== undefined">
              <label>{{ 'telemetry.technical.rpm' | transloco }}</label>
              <span class="value">{{ currentData.rpm | number:'1.0-0' }}</span>
            </div>
            <div class="data-row" *ngIf="currentData.engineTemp !== undefined">
              <label>{{ 'telemetry.technical.temperature' | transloco }}</label>
              <span class="value">{{ currentData.engineTemp | number:'1.1-1' }}°C</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Card de Sistema -->
      <div class="col-md-6 mb-3">
        <div class="data-card">
          <div class="card-header">
            <i class="bi bi-battery-charging"></i>
            <h5>{{ 'telemetry.technical.system' | transloco }}</h5>
          </div>
          <div class="card-body">
            <div class="data-row" *ngIf="currentData.batteryVoltage !== undefined">
              <label>{{ 'telemetry.technical.battery' | transloco }}</label>
              <span class="value">{{ currentData.batteryVoltage | number:'1.1-1' }}V</span>
            </div>
            <div class="data-row" *ngIf="currentData.fuelLevel !== undefined">
              <label>{{ 'telemetry.technical.fuel' | transloco }}</label>
              <span class="value">{{ currentData.fuelLevel | number:'1.0-0' }}%</span>
            </div>
            <div class="data-row">
              <label>{{ 'telemetry.technical.lastUpdate' | transloco }}</label>
              <span class="value" [class.fresh]="isDataFresh()">
                {{ getTimeSinceUpdate() }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Timestamp -->
    <div class="timestamp">
      <i class="bi bi-clock"></i>
      {{ currentData.timestamp | date:'dd/MM/yyyy HH:mm:ss' }}
    </div>
  </div>

  <!-- Mensagem quando não há dados -->
  <div class="no-data" *ngIf="!currentData">
    <div class="no-data-content">
      <i class="bi bi-inbox"></i>
      <p *ngIf="connectionStatus.status === 'connected'">
        {{ 'telemetry.messages.waitingData' | transloco }}
      </p>
      <p *ngIf="connectionStatus.status === 'disconnected'">
        {{ 'telemetry.messages.connectToReceive' | transloco }}
      </p>
      <p *ngIf="connectionStatus.status === 'reconnecting'">
        {{ 'telemetry.messages.tryingReconnect' | transloco }}
      </p>
    </div>
  </div>
</div>
